import script from "./GrowthList.vue?vue&type=script&setup=true&lang=js"
export * from "./GrowthList.vue?vue&type=script&setup=true&lang=js"

import "./GrowthList.vue?vue&type=style&index=0&id=9dae4e2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dae4e2e"]])

export default __exports__